import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=fac6c44a&scoped=true"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=fac6c44a&prod&lang=scss&scoped=true"
import style1 from "./Marketing.vue?vue&type=style&index=1&id=fac6c44a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6c44a",
  null
  
)

export default component.exports